import { createFileRoute } from '@tanstack/react-router';
import { CreateStandingOrderPage } from '../components/pages/StandingOrdersPage/CreateStandingOrderPage';

export const Route = createFileRoute('/account/standing-orders_/create')({
  component: CreateStandingOrderPage,
});
